import * as _ from "lodash-es";

export default {
  namespaced: true,
  state: {
    defaultOrderLines: [],
  },
  mutations: {
    setDefaultOrderLines: function (state, defaultOrderLines) {
      state.defaultOrderLines = defaultOrderLines;
    },
  },
  getters: {
    defaultOrderLinesByPaymentName(state) {
      return _.groupBy(Object.values(state.defaultOrderLines), "name");
    },
  },
};
